<template>
	<div class="player-content-info">
		<div class="title">
			<a
				v-if="isEmbedded"
				:href="event.url"
				target="_blank"
			><span>{{ info.name }}</span></a>
			<span v-else>{{ info.name }}</span>
		</div>
		<div class="subtitle">
			<span
				v-if="info.eventContext"
				class="event-context"
			> {{ info.eventContext }} &bull; </span>
			<span v-if="info.parentCategory"> {{ info.parentCategory }} &bull;</span>
			<span v-if="info.childCategory"> {{ info.childCategory }} &bull;</span>
			<span v-if="info.eventDateTime"> {{ info.eventDateTime }} </span>
			<span v-if="info.location">
				&bull; {{ info.location }}
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDateTime } from '@shared/utils/timeUtils';
import { getLocation, getLeagueName } from '@shared/utils/eventUtils';
import { CategoryChild } from '@shared/enums/CategoryChild';

export default {
	name:  'PlayerContentInfo',
	props: {
		event: {
			type:     Object,
			required: true,
		},
	},
	computed: {
		...mapGetters({
			isEmbedded: 'app/isEmbedded',
		}),
		info() {
			const parentCategory = this.$Helpers.ucfirst(this.$I18n.trans('event.category.parent')[this.event.categoryParent] ?? '');
			const childCategory = this.$Helpers.ucfirst(this.$I18n.trans('event.category.child')[this.event.categoryChild] ?? '');
			const leagueName = getLeagueName(this.event) || childCategory;

			return {
				name:          this.event.name || this.$I18n.trans('commons.unnamed'),
				eventContext:  this.event.contextable && this.event.contextable.name,
				parentCategory,
				childCategory: this.event.categoryChild === CategoryChild.MATCH_LEAGUE ? leagueName : childCategory,
				eventDateTime: getDateTime(this.event.startTimestamp + (this.event.kickoffOffsetMinutes * 60)),
				location:      getLocation(this.event),
			};
		},
	},
};
</script>

<style scoped lang="scss">
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.player-content-info {
	padding-top: 24px;
	padding-left: 24px;
	padding-right: 24px;

	&::before {
		z-index: -1;
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 170%;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0.9) 14.42%, rgba(0, 0, 0, 0) 100%);
		opacity: 0.8;
		transition: opacity 250ms cubic-bezier(0.33, 0.7, 0.32, 1) 0ms;
		pointer-events: none;
	}

	.title,
	.title a {
		font-weight: 300;
		font-size: 40px;
		line-height: 48px;
		letter-spacing: -1.2px;
		color: var(--color-white);
	}

	.subtitle {
		@extend .text-sm;
		margin-top: 8px;

		.event-context {
			color: var(--color-hype-yellow);
		}
	}

	.title,
	.subtitle {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
}

.player-content-info {
	@media (max-width:1440px) {
		.title,
		.title a {
			@include text-lg-2;
		}

		.subtitle {
			@include text-sm-2;
		}
	}

	@media (max-width:800px) {
		.title,
		.title a {
			@include text-lg-1;
		}

		.subtitle {
			@include text-sm-2;
		}
	}

	@media (max-width:640px) {
		.title,
		.title a {
			@include text-md-2;
		}
		.subtitle {
			@include text-sm-1;
		}
	}

	@media (max-width:400px) {
		.title,
		.title a {
			@include text-sm-2;
		}
		.subtitle {
			display: none;
		}
	}

	@media (max-width: 290px) {
		.title,
		.title a {
			@include text-sm-1;
		}

		.subtitle {
			display: none;
		}
	}
}
</style>
